<fui-button
    type="button-icon"
    borderRadius="circle"
    color="flat"
    textColor="white"
    icon="database-alert-outline"
    (clickEvent)="onButtonClick()"
></fui-button>

<ng-container *ngIf="(itemsCount$ | async) !== null">
    <div
        class="absolute -top-1.5 -right-1 w-5 h-5 rounded-full text-xxs bg-error-input text-on-accent flex items-center justify-center font-medium shadow"
    >
        {{ itemsCount$ | async }}
    </div>
</ng-container>
